<template>
  <b-dropdown-item v-if="actionRoute" :to="actionRoute">
    <span class="d-flex align-items-center">
      <i v-if="action.icon" :class="['fa', 'mr-2', action.icon]" />
      <span>{{ action.name }}</span>
    </span>
  </b-dropdown-item>
  <b-dropdown-item v-else-if="actionLink" :href="actionLink">
    <span class="d-flex align-items-center">
      <i v-if="action.icon" :class="['fa', 'mr-2', action.icon]" />
      <span>{{ action.name }}</span>
    </span>
  </b-dropdown-item>
  <b-dropdown-item v-else @click="actionFn">
    <span class="d-flex align-items-center">
      <i v-if="action.icon" :class="['fa', 'mr-2', action.icon]" />
      <span>{{ action.name }}</span>
    </span>
  </b-dropdown-item>
</template>

<script lang="ts">
import type { Action } from '@/types/Components/Actions'
import type { Assignment } from '@/types/Models/Assignment'
import { BDropdownItem } from 'bootstrap-vue-next'
import { computed, type ComputedRef, defineComponent, type PropType } from 'vue'
import { useActionHandlers } from '@/composables/Assignment/useActionHandlers'

export default defineComponent({
  name: 'DropdownItem',
  components: { BDropdownItem },
  props: {
    action: {
      type: Object as PropType<Action>,
      required: true,
    },
    assignment: {
      type: Object as PropType<Assignment>,
      required: true,
    },
  },
  setup(props) {
    const assignment: ComputedRef<Assignment> = computed(() => props.assignment)
    const action: ComputedRef<Action> = computed(() => props.action || ({} as Action))
    return {
      ...useActionHandlers(assignment, action),
    }
  },
})
</script>
